document.addEventListener('DOMContentLoaded', () => {
    const yElement = document.getElementById("y");
    if (yElement) {
        yElement.textContent = new Date().getFullYear();
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                observer.unobserve(entry.target); // Stop watching once revealed
            }
        });
    }, { 
        threshold: 0.01,
        rootMargin: '0px 0px 50px 0px' // Trigger 50px before entering
    });

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));



    // AJAX Add to Cart
    document.addEventListener('submit', function(e) {
        const form = e.target.closest('form[action="/cart/add"]');
        if (form) {
            e.preventDefault();
            const submitButton = form.querySelector('[type="submit"]');
            const originalText = submitButton ? submitButton.textContent : 'Add to Cart';
            
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.innerHTML = `<span class="spinner"></span>`; // 4. Spinner State
            }

            const formData = new FormData(form);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(item => {
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.textContent = originalText;
                }
                refreshCart(true); // Open drawer on add
            })
            .catch(error => {
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.textContent = originalText;
                }
                console.error('Error adding to cart:', error);
            });
        }
    });

    // Lightbox / Zoom for Product Images
    const mediaItems = document.querySelectorAll('.product-media-item img');
    if (mediaItems.length > 0) {
        let currentIndex = 0;
        const mediaSources = Array.from(mediaItems).map(img => img.src);

        const lightbox = document.createElement('div');
        lightbox.id = 'product-lightbox';
        lightbox.innerHTML = `
            <div class="lightbox-overlay"></div>
            <div class="lightbox-content">
                <button class="lightbox-nav prev" aria-label="Previous image">&larr;</button>
                <img src="" alt="Zoomed view">
                <button class="lightbox-nav next" aria-label="Next image">&rarr;</button>
                <button class="lightbox-close" aria-label="Close">&times;</button>
            </div>
        `;
        document.body.appendChild(lightbox);

        const lightboxImg = lightbox.querySelector('img');
        const closeBtn = lightbox.querySelector('.lightbox-close');
        const overlay = lightbox.querySelector('.lightbox-overlay');
        const prevBtn = lightbox.querySelector('.prev');
        const nextBtn = lightbox.querySelector('.next');

        const updateLightbox = (index) => {
            currentIndex = (index + mediaSources.length) % mediaSources.length;
            lightboxImg.style.opacity = '0';
            setTimeout(() => {
                lightboxImg.src = mediaSources[currentIndex];
                lightboxImg.style.opacity = '1';
            }, 150);
        };

        mediaItems.forEach((img, index) => {
            img.style.cursor = 'zoom-in';
            img.addEventListener('click', () => {
                updateLightbox(index);
                lightbox.classList.add('active');
                document.body.style.overflow = 'hidden';
            });
        });

        const closeLightbox = () => {
            lightbox.classList.remove('active');
            document.body.style.overflow = '';
        };

        prevBtn.addEventListener('click', (e) => { e.stopPropagation(); updateLightbox(currentIndex - 1); });
        nextBtn.addEventListener('click', (e) => { e.stopPropagation(); updateLightbox(currentIndex + 1); });
        closeBtn.addEventListener('click', closeLightbox);
        overlay.addEventListener('click', closeLightbox);

        document.addEventListener('keydown', (e) => {
            if (!lightbox.classList.contains('active')) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') updateLightbox(currentIndex - 1);
            if (e.key === 'ArrowRight') updateLightbox(currentIndex + 1);
        });
    }

    // Global function to update quantities or remove items
    window.updateCartItem = function(key, qty) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(res => res.json())
        .then(cart => {
            refreshCart(false); // Don't snap scroll, just refresh
        });
    }

    function refreshCart(openDrawer) {
        fetch('/?section_id=cart-drawer')
        .then(res => res.text())
        .then(html => {
           const parser = new DOMParser();
           const doc = parser.parseFromString(html, 'text/html');
           const newContent = doc.getElementById('CartDrawerContent');
           const currentContent = document.getElementById('CartDrawerContent');
           
           if (newContent && currentContent) {
               currentContent.innerHTML = newContent.innerHTML;
           }
           
           updateCartCount();
           if (openDrawer) {
             const drawer = document.getElementById('cart-drawer');
             if (drawer && !drawer.classList.contains('active')) {
               toggleCart();
             }
           }
        });
    }

    function updateCartCount() {
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const countElements = document.querySelectorAll('.cart-count');
            countElements.forEach(el => {
                el.textContent = cart.item_count;
                if (cart.item_count > 0) {
                    el.classList.add('is-active');
                } else {
                    el.classList.remove('is-active');
                }
            });
        });
    }

    // Product Mobile Carousel Dot Sync
    const carousel = document.getElementById('product-media-carousel');
    const dots = document.querySelectorAll('.pagination-dot');

    if (carousel && dots.length > 0) {
        const dotObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = entry.target.getAttribute('data-index');
                    dots.forEach(dot => dot.classList.remove('active'));
                    const activeDot = document.querySelector(`.pagination-dot[data-index="${index}"]`);
                    if (activeDot) activeDot.classList.add('active');
                }
            });
        }, { 
            root: carousel,
            threshold: 0.6 
        });

        document.querySelectorAll('.product-media-item').forEach(item => {
            dotObserver.observe(item);
        });

        // Click dots to scroll
        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                const index = dot.getAttribute('data-index');
                const target = carousel.querySelector(`.product-media-item[data-index="${index}"]`);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
            });
        });
    }
});

// Mobile Menu Toggle
function toggleMenu() {
    const header = document.querySelector('.header');
    if (!header) return;
    const isOpen = header.classList.toggle('nav-open');
    const toggle = header.querySelector('.menu-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

// Close the mobile menu when a link is chosen, on Esc, or when back on desktop
document.addEventListener('click', (e) => {
    const header = document.querySelector('.header');
    if (header && header.classList.contains('nav-open')) {
        if (e.target.closest('.mobile-menu a')) {
            toggleMenu();
        } else if (!e.target.closest('.header')) {
            toggleMenu();
        }
    }
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const header = document.querySelector('.header');
        if (header && header.classList.contains('nav-open')) toggleMenu();
    }
});
window.addEventListener('resize', () => {
    if (window.innerWidth > 600) {
        const header = document.querySelector('.header');
        if (header && header.classList.contains('nav-open')) toggleMenu();
    }
}, { passive: true });

// Cart Toggle Logic
function toggleCart() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    
    const isOpening = !drawer.classList.contains('active');
    drawer.classList.toggle('active');
    
    // Prevent body scroll when cart is open
    if (isOpening) {
        document.body.style.overflow = 'hidden';
        
        // Focus first interactive element
        setTimeout(() => {
            const focusable = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable.length) focusable[0].focus();
        }, 100);

        drawer.addEventListener('keydown', trapCartFocus);
        document.addEventListener('keydown', closeCartOnEsc);
    } else {
        document.body.style.overflow = '';
        drawer.removeEventListener('keydown', trapCartFocus);
        document.removeEventListener('keydown', closeCartOnEsc);
        
        const toggle = document.querySelector('.cart-toggle');
        if (toggle) toggle.focus();
    }
}

function trapCartFocus(e) {
    if (e.key !== 'Tab') return;
    const drawer = document.getElementById('cart-drawer');
    const focusable = Array.from(drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
        .filter(el => el.offsetParent !== null);
    
    if (focusable.length === 0) return;
    
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
        if (document.activeElement === first) {
            last.focus();
            e.preventDefault();
        }
    } else {
        if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
        }
    }
}

// 2. Header Scroll Behavior (Smart Sticky)
let lastScrollY = window.scrollY;
let ticking = false;
const header = document.querySelector('.header');

if (header) {
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                if (window.scrollY > 100) {
                    if (window.scrollY > lastScrollY) {
                        header.classList.add('header--hidden');
                    } else {
                        header.classList.remove('header--hidden');
                    }
                } else {
                    header.classList.remove('header--hidden');
                }
                lastScrollY = window.scrollY;
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });
}

function closeCartOnEsc(e) {
    if (e.key === 'Escape') {
        const drawer = document.getElementById('cart-drawer');
        if (drawer && drawer.classList.contains('active')) {
            toggleCart();
        }
    }
}
// Product Variant Change Handler (Radio/Pills)
function onVariantChangeRadio(input) {
    const available = input.getAttribute('data-available') === 'true';
    const price = input.getAttribute('data-price');
    const button = document.getElementById('AddToCart');
    const priceElement = document.querySelector('.product-price-page');
    const hiddenIdInput = document.getElementById('variant-id-hidden');

    if (hiddenIdInput) {
        hiddenIdInput.value = input.value;
    }

    // Sync URL with variant ID
    const url = new URL(window.location.href);
    url.searchParams.set('variant', input.value);
    window.history.replaceState({}, '', url.toString());

    if (button) {
        if (available) {
            button.disabled = false;
            button.textContent = 'Add to Cart';
        } else {
            button.disabled = true;
            button.textContent = 'Sold Out';
        }
    }

    if (priceElement && price) {
        priceElement.textContent = price;
    }
}
